<template>
    <oss-dialog
        v-if="dialog"
        v-model="dialog"
        :max-width="!$vuetify.display.mobile ? '950px' : undefined"
        :min-height="!$vuetify.display.mobile ? '950px' : undefined"
        :fullscreen="$vuetify.display.mobile"
        :hide-overlay="$vuetify.display.mobile"
        title="Bilan mensuel"
        min-width="90vw"
        @keydown.esc="dialog = false"
    >
        <v-card class="uploadDocument">
            <!-- <v-toolbar  color="primary" class="elevation-0">
                    <v-toolbar-title class="ml-5">Bilan mensuel</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="close()">
                        <v-icon>$close</v-icon>
                    </v-btn>
                </v-toolbar> -->
            <v-card-text :class="!$vuetify.display.mobile ? '' : 'pa-2'">
                <v-card style="background-color: transparent" elevation="0">
                    <v-window touchless style="min-height: 27vh">
                        <v-window-item :value="1">
                            <v-row class="d-flex justify-center py-1">
                                <v-col
                                    :cols="$vuetify.display.mobile ? '12' : '12'"
                                    class="my-0 pa-2"
                                >
                                    <v-row>
                                        <v-col :cols="$vuetify.display.mobile ? '12' : '1'">
                                            <v-btn-icon
                                                icon="$fa-chevron-left"
                                                @click="$refs.calendar.prev()"
                                            />
                                        </v-col>
                                        <v-col :cols="$vuetify.display.mobile ? '12' : '1'">
                                            <v-btn-icon
                                                icon="$fa-chevron-right"
                                                @click="$refs.calendar.next()"
                                            />
                                        </v-col>
                                        <v-col :cols="$vuetify.display.mobile ? '12' : '6'">
                                            <span
                                                style="
                                                    color: #5fc9b8;
                                                    font-size: 22pt;
                                                    text-transform: capitalize;
                                                "
                                                class="mt-2 d-flex justify-start align-center"
                                            >
                                                {{ actualMonth }} - {{ actualYear }}
                                            </span>
                                        </v-col>
                                    </v-row>
                                </v-col>
                            </v-row>
                            <v-row class="d-flex justify-center py-1">
                                <v-calendar
                                    ref="calendar"
                                    v-model="focus"
                                    :events="events"
                                    :event-color="getEventColor"
                                    :start="dayCalendarStart"
                                    :end="dayCalendarEnd"
                                    color="secondary"
                                    type="month"
                                    @click:event="showEvent"
                                    @change="updateDates"
                                />
                                <v-menu
                                    v-model="selectedOpen"
                                    :close-on-content-click="false"
                                    :activator="selectedElement"
                                    offset-x
                                    max-width="350px"
                                >
                                    <v-card color="grey lighten-4" min-width="350px" flat>
                                        <v-toolbar :color="selectedEvent.color" dark>
                                            <v-toolbar-title v-html="selectedEvent.affDate" />
                                            <v-spacer />
                                            <v-btn
                                                text
                                                color="white"
                                                @click="selectedOpen = false"
                                                icon="$close"
                                            >
                                            </v-btn>
                                        </v-toolbar>
                                        <v-card-text>
                                            <div>
                                                <span
                                                    style="font-weight: bold; font-size: 12pt"
                                                    v-html="selectedEvent.grossAmount"
                                                />
                                            </div>
                                            <div>
                                                <span
                                                    style="font-weight: bold; font-size: 10pt"
                                                    v-html="selectedEvent.amounts"
                                                />
                                            </div>
                                        </v-card-text>
                                        <v-card-actions>
                                            <v-spacer />
                                            <v-btn
                                                v-if="selectedEvent.type !== 'warning'"
                                                class="mr-5"
                                                @click="openTicketZEdition(selectedEvent.zTill)"
                                                variant="text"
                                            >
                                                Ouvrir
                                            </v-btn>
                                            <v-btn
                                                v-else
                                                class="mr-5"
                                                @click="$router.push({ name: 'ztillReceipts' })"
                                                variant="text"
                                            >
                                                Créer
                                            </v-btn>
                                        </v-card-actions>
                                    </v-card>
                                </v-menu>
                            </v-row>
                        </v-window-item>
                    </v-window>
                </v-card>
            </v-card-text>
        </v-card>
    </oss-dialog>
</template>

<script lang="ts">
import gql from "graphql-tag";
import moment from "moment-timezone";
import { start } from "repl";
import { newCommonFormatCurrency } from "../../../../backend/src/common/services/mathServices";

import { Apollo } from "@/decorators";

import GET_AUDITCHECKRESULT from "../../graphql/audit/GetAuditCheckResult.gql";
import ZTILLS_CHECK from "../../graphql/audit/AuditItems.gql";
import { Component, Vue, toNative } from "vue-facing-decorator";
import { Prop } from "vue-facing-decorator";

@Component({
    emits: ["update:active"],
})
export class CheckBilanZTillWizard extends Vue {
    focus: string = "";

    selectedEvent: any = {};
    selectedElement: any = null;
    selectedOpen: boolean = false;

    events: any = [];
    startDay: any = "";
    endDay: any = "";
    actualMonth: any = "";
    actualYear: any = "";
    monthNb: any = "";

    @Prop({ type: Boolean }) readonly active!: Boolean;
    @Prop({ default: "" }) readonly companyId: string;
    @Prop({ default: true }) readonly showFirstPrevious: boolean;
    @Prop({ default: "" }) readonly inGlobalStep: string;
    @Prop({ default: "" }) dayCalendarStart: string;
    @Prop({ default: "" }) dayCalendarEnd: string;
    @Prop({ default: "" }) auditCheckKey: string;

    get dialog() {
        return this.active;
    }

    set dialog(event) {
        this.$emit("update:active", event);
    }

    close() {
        this.$emit("update:active", false);
    }

    // eslint-disable-next-line no-shadow
    updateDates({ start, end }) {
        this.actualMonth = moment()
            .months(start.month - 1)
            .format("MMMM");
        this.actualYear = moment().years(start.year).format("YYYY");
        this.monthNb = moment()
            .months(start.month - 1)
            .format("MM");
        this.getEvents(this.items);
        this.checkWarning(this.items);
    }

    // @todo Vincent refaire la création des dates pour le calendar dans une fonction synthétisé
    getEvents(items) {
        this.events = [];
        const events = [];
        let date = {};
        for (const ztill of items) {
            const ztillPeriod = this.getPeriodFormated(ztill);
            if (ztillPeriod === "Mensuel") {
                date = this.getMonthDate(ztill);
                if (date[0] !== "" && date[1] !== "") {
                    // Event pushed
                    events.push({
                        zTill: ztill,
                        name: ztillPeriod + " - " + newCommonFormatCurrency(ztill.grossAmount),
                        start: date[0],
                        end: date[1],
                        affDate: this.getDateFormated(ztill) + " - " + ztillPeriod,
                        color: "calendar_yellow",
                        grossAmount:
                            "Montant du Z de caisse : " +
                            newCommonFormatCurrency(ztill.grossAmount),
                        amounts:
                            "HT : " +
                            newCommonFormatCurrency(ztill.netAmount) +
                            " | TVA : " +
                            newCommonFormatCurrency(ztill.vatAmount),
                        type: "mois",
                    });
                }
            } else if (ztillPeriod === "Journée") {
                const ztillDate = ztill.date.substring(0, ztill.date.indexOf("T"));
                // Event pushed in calendar
                events.push({
                    zTill: ztill,
                    name: ztillPeriod + " - " + newCommonFormatCurrency(ztill.grossAmount),
                    start: ztillDate,
                    end: ztillDate,
                    affDate: this.getDateFormated(ztill) + " - " + ztillPeriod,
                    color: "secondary",
                    grossAmount:
                        "Montant du Z de caisse : " + newCommonFormatCurrency(ztill.grossAmount),
                    amounts:
                        "HT : " +
                        newCommonFormatCurrency(ztill.netAmount) +
                        " | TVA : " +
                        newCommonFormatCurrency(ztill.vatAmount),
                    type: "day",
                });
            } else {
                const ztillDate = ztill.date.substring(0, ztill.date.indexOf("T"));
                let startHour = "";
                let endHour = "";
                if (ztillPeriod === "Matin") {
                    startHour = ztillDate + "T08:00";
                    endHour = ztillDate + "T12:00";
                } else {
                    startHour = ztillDate + "T14:00";
                    endHour = ztillDate + "T18:00";
                }
                // Event pushed in calendar
                events.push({
                    zTill: ztill,
                    name: ztillPeriod + " - " + newCommonFormatCurrency(ztill.grossAmount),
                    start: startHour,
                    end: endHour,
                    affDate: this.getDateFormated(ztill) + " - " + ztillPeriod,
                    color: "calendar_green",
                    grossAmount:
                        "Montant du Z de caisse : " + newCommonFormatCurrency(ztill.grossAmount),
                    amounts:
                        "HT : " +
                        newCommonFormatCurrency(ztill.netAmount) +
                        " | TVA : " +
                        newCommonFormatCurrency(ztill.vatAmount),
                    type: "half",
                });
            }
        }
        this.events = events;
    }

    async monthIgnore(month) {
        const keyACR = this.auditCheckKey + "_" + month;
        const result = await this.$apollo.query({
            query: GET_AUDITCHECKRESULT,
            variables: {
                key: keyACR,
                company: this.companyId,
            },
        });
        if (
            result &&
            result.data &&
            result.data.auditCheckResults &&
            result.data.auditCheckResults[0]
        ) {
            const status = result.data.auditCheckResults[0].status;
            if (status === "IGNORE") {
                return true;
            }
        }
        return false;
    }

    async checkWarning(items) {
        const events = [];

        const month = moment(this.monthNb).month();
        const year = this.actualYear;

        const monthIndex = month;
        const date = new Date(year, monthIndex, 1);

        // Ignore the warnings
        const ignore = await this.monthIgnore(moment(date).format("YYYY-MM"));

        const listDate = [];
        while (date.getMonth() === monthIndex) {
            listDate.push(year + "-" + (month + 1) + "-" + date.getDate() + " AM");
            listDate.push(year + "-" + (month + 1) + "-" + date.getDate() + " PM");
            date.setDate(date.getDate() + 1);
        }

        // Sorted list of ZTills
        items.sort((a, b) => (moment(a.date) > moment(b.date) ? 1 : -1));
        let lastPeriodWarning = "";
        for (let i = 0; i < listDate.length; i++) {
            const result = this.checkPeriod(listDate[i], items);
            if (!result) {
                const array = [listDate[i].split(" ")];
                const day = moment(array[0][0]).format("YYYY-MM-DD");
                const period = array[0][1];
                // Condition to avoid having twice warning per day
                if (lastPeriodWarning !== day && !ignore) {
                    this.events.push({
                        name: "Warning",
                        start: day,
                        affDate: "Z de caisse manquant",
                        grossAmount: "Aucun Z de caisse n'a été enregistré sur la période",
                        color: "calendar_red",
                        type: "warning",
                    });
                }
                lastPeriodWarning = day;
            }
        }
    }

    // Check if the date inputed is in a ztill period
    checkPeriod(date, items) {
        const array = [date.split(" ")];
        const day = moment(array[0][0]).format("YYYY-MM-DD");
        const period = array[0][1];

        for (const ztill of items) {
            const ztillDate = ztill.date.substring(0, ztill.date.indexOf("T"));
            if (ztill.period === "DA" && day === ztillDate) {
                return true;
            }
            if (ztill.period === "MO") {
                const ztillFinPeriod = moment(ztillDate).endOf("month").format("YYYY-MM-DD");
                const ztillStartPeriod = moment(ztillDate).startOf("month").format("YYYY-MM-DD");
                if (day >= ztillStartPeriod && day <= ztillFinPeriod) {
                    return true;
                }
            }
            if (day === ztillDate && period === ztill.period) {
                return true;
            }
        }
        return null;
    }

    getEventColor(event) {
        return event.color;
    }

    showEvent({ nativeEvent, event }) {
        const open = () => {
            this.selectedEvent = event;
            this.selectedElement = nativeEvent.target;
            setTimeout(() => (this.selectedOpen = true), 10);
        };

        if (this.selectedOpen) {
            this.selectedOpen = false;
            setTimeout(open, 10);
        } else {
            open();
        }

        nativeEvent.stopPropagation();
    }

    getDateFormated(zTill) {
        const date = zTill.date;
        if (date) {
            return moment(date).format("DD/MM/YYYY");
        }
        return "";
    }

    getMonthDate(zTill) {
        if (zTill.date) {
            // Get month and year of the date
            const d = moment(zTill.date);
            const month = d.month();
            const year = d.year();

            // Get first and last day of the month
            const startDate = moment([year, month]);
            const endDate = moment(startDate).endOf("month");

            // Set the right format
            const startOfMonth = moment(startDate).format("YYYY-MM-DD");
            const endOfMonth = moment(endDate).format("YYYY-MM-DD");

            return [startOfMonth, endOfMonth];
        }

        debugger;
        return "";
    }

    getPeriodFormated(zTill) {
        const period = zTill.period;
        if (period) {
            switch (period) {
                case "AM":
                    return "Matin";
                case "PM":
                    return "Après-midi";
                case "DA":
                    return "Journée";
                case "MO":
                    return "Mensuel";
                default:
                    return null;
            }
        } else return null;
    }

    openTicketZEdition(item: any) {
        this.$router.push({
            name: "zTillReceipt",
            params: {
                companyId: this.companyId,
                id: item.id,
            },
        });
    }

    get auditCheck() {
        return this.$route.params.auditCheck;
    }

    newCommonFormatCurrency(value, options = undefined) {
        return newCommonFormatCurrency(value, undefined);
    }

    @Apollo({
        query: ZTILLS_CHECK,
        variables() {
            return {
                companyId: this.companyId,
                auditCheckKey: this.auditCheckKey,
            };
        },
        skip() {
            return !this.companyId;
        },
        specificResult({ data, loading, networkStatus }: any) {
            if (!loading) {
                if (data) {
                    this.items = data.auditItems.items;
                    this.getEvents(this.items);
                    this.checkWarning(this.items);
                }
            }
        },
    })
    items: Array<any> = [];
}

export default toNative(CheckBilanZTillWizard);
</script>
<style lang="scss" scoped>
.v-list-item {
    min-height: auto !important;
}
</style>
